import React from 'react';
import { useDispatch } from 'react-redux';
import VideoModule from './VideoModule/VideoModule';
import SequencerPadView from './SequencerPadView/SequencerPadView';
import CommandVisualizer from './CommandVisualizer';
import { setSelectedPad } from '../../store/sequencerSlice';

const Sequencer: React.FC<{ sequencerId: string }> = ({ sequencerId }) => {
  const dispatch = useDispatch();

  const handlePadSelect = (padId: number) => {
    dispatch(setSelectedPad({ sequencerId, padId }));
  };

  const sequencerNumber = sequencerId.replace('seq', '');

  return (
    <div
      className="sequencer p-2"
      style={{
        width: '340px',
        maxWidth: '100%',
        backgroundColor: 'var(--bg-secondary)',
        border: '1px solid var(--border-color)'
      }}
    >
      <div className="d-flex align-items-center mb-1" style={{ color: 'var(--text-muted)' }}>
        <span style={{ fontSize: '10px', letterSpacing: '1px' }}>SEQ {sequencerNumber}</span>
      </div>
      <div className="p-1">
        <CommandVisualizer sequencerId={sequencerId} />
      </div>
      <VideoModule videoModuleId={sequencerId} />
      <SequencerPadView
        sequencerId={sequencerId}
        onPadSelect={handlePadSelect}
      />
    </div>
  );
};

export default Sequencer;
